import { MapPin, Phone, ArrowDown } from "lucide-react";
import { imgUrl } from "../../lib/api";
import { waLink, telHref } from "../../lib/site";
import { WhatsAppIcon } from "./WhatsAppFloat";

export const Hero = ({ content, banner }) => {
  const wa = waLink(content, content.whatsapp_message);
  return (
    <section id="inicio" data-testid="hero-section" className="relative min-h-[100svh] flex items-end overflow-hidden grain">
      {banner && (
        <img src={imgUrl(banner.src)} alt={banner.title || "Vienna Palace Hotel"} className="absolute inset-0 w-full h-full object-cover hero-zoom" fetchpriority="high" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/65 to-black/45" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent" />
      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 lg:px-10 pb-16 sm:pb-24 pt-32">
        <p className="font-caps text-[11px] sm:text-xs text-[#E6C687] reveal" data-testid="hero-eyebrow">{content.hero_eyebrow}</p>
        <h1 data-testid="hero-title" className="font-display text-5xl sm:text-6xl lg:text-8xl font-medium leading-[0.95] mt-5 max-w-4xl reveal" style={{ animationDelay: "120ms" }}>
          <span className="gold-text">{content.hero_title}</span>
        </h1>
        <p data-testid="hero-tagline" className="mt-6 text-base sm:text-lg text-zinc-300 max-w-xl leading-relaxed reveal" style={{ animationDelay: "240ms" }}>
          {content.hero_subtitle}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 reveal" style={{ animationDelay: "360ms" }}>
          <a href="#acomodacoes" data-testid="hero-cta-accommodations" className="btn-outline-gold">
            {content.btn_accommodations} <ArrowDown size={16} />
          </a>
          {wa ? (
            <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="hero-cta-whatsapp" className="btn-gold">
              <WhatsAppIcon className="w-4 h-4" /> {content.btn_whatsapp}
            </a>
          ) : (
            <a href={telHref(content.phone)} data-testid="hero-cta-phone" className="btn-gold"><Phone size={16} /> {content.phone}</a>
          )}
        </div>
        <div data-testid="hero-quick-bar" className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-4 sm:gap-10 text-sm text-zinc-400 reveal" style={{ animationDelay: "480ms" }}>
          <span className="flex items-center gap-2"><MapPin size={15} className="text-[#D4AF37]" /> {content.address_street} · {content.address_district}, {content.address_city}</span>
          <a href={telHref(content.phone)} className="flex items-center gap-2 hover:text-[#E6C687] transition-colors"><Phone size={15} className="text-[#D4AF37]" /> {content.phone_label}: {content.phone}</a>
        </div>
      </div>
      {banner?.is_sample && <span className="absolute top-24 right-5 z-10 text-[10px] uppercase tracking-widest text-zinc-200 bg-black/70 px-2 py-1">Imagem ilustrativa</span>}
    </section>
  );
};
